// extracted by mini-css-extract-plugin
export default {"root":"VendorSelector_root__olm+n"};